import Vue from 'vue'
import VueTimers from 'vue-timers'
import VueApollo from 'vue-apollo'
import MarqueeText from 'vue-marquee-text-component';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VueTimers)
const httpLink = createHttpLink({
  uri: process.env.VUE_APP_API_URL
});

Vue.component('marquee-text', MarqueeText)

// const authLink = setContext((_, { headers }) => {
//   const token = localStorage.getItem('token');
//   return {
//     headers: {
//       ...headers,
//       authorization: token ? `Bearer ${token}` : "",
//     }
//   }
// });

const apolloClient = new ApolloClient({
  // link: authLink.concat(httpLink),
  link: httpLink,
  cache: new InMemoryCache()
});

Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

new Vue({
  apolloProvider,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
